import {Component} from "@angular/core";
import {Names} from "../names";
import {ApplicationBarComponent} from "./ApplicationBarComponent";

@Component({
    selector: Names.applicationBarLayout.selector,
    template: require("./applicationBarLayout.html")
})
export class ApplicationBarLayoutComponent {

}



// WEBPACK FOOTER //
// ./src/app/ApplicationBar/ApplicationBarLayoutComponent.ts